// Client-side auto image compression before upload.
// Resizes long side to <=1600px and encodes JPEG q~0.82. Keeps text/part numbers legible.
// Non-image files are returned unchanged.
const MAX_SIDE = 1600;
const QUALITY = 0.82;
const SMALL_BYTES = 400 * 1024; // already small enough -> skip

export async function compressImage(file) {
  if (!file || !file.type?.startsWith("image/")) return file;
  if (file.size <= SMALL_BYTES) return file;
  try {
    const bitmap = await createImageBitmap(file);
    let { width, height } = bitmap;
    const longSide = Math.max(width, height);
    if (longSide > MAX_SIDE) {
      const scale = MAX_SIDE / longSide;
      width = Math.round(width * scale);
      height = Math.round(height * scale);
    }
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close?.();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", QUALITY));
    if (!blob || blob.size >= file.size) return file; // no gain -> keep original
    return new File([blob], (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file; // any failure -> upload original, backend also compresses
  }
}
